/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../js-controller';
import { getQuery } from '@root/src/framework/scripts/utils/url';


import modal from 'bootstrap/js/dist/modal';

import Glide from '@glidejs/glide';
import { defineAsyncComponent } from 'vue';

import { markElementReady, waitForElement, elementReady } from '@root/src/framework/scripts/helpers/element-ready';

export default (app: App) => {
    app.vueApp.component(
        'buyer-type-selection',
        defineAsyncComponent(async () => import('./BuyerTypeButtonSelection.vue'))
    );

    const controller = new JsController(app, 'hub-welcome-modal');
    controller.addMountFunction(() => {
        mountComponent(controller);
    });

    return controller.init();
};

export function mountComponent(controller: JsController) {
    const elements = document.querySelectorAll<HTMLElement>('.welcome-modal-carousel');
    let modalElement = document.querySelector<HTMLElement>('#hub-welcome-modal');
    if (modalElement) {
        const modalSubmitButton = modalElement.querySelector<HTMLElement>('#modal-submit-button');
        if (modalSubmitButton) {
            controller.addListener(modalSubmitButton, 'click', () => {
                //when user moves out of modal 
                //check if backend update is completed if not display loading modal and reload page
                const buyerTypeReference = document.querySelector<HTMLElement>('.buyer-type-reference');
                if (buyerTypeReference) {
                    if (buyerTypeReference.dataset.buyerType) {
                        toggleLoadingModal();
                        elementReady(buyerTypeReference).then(() => {
                            window.location.reload();
                        });
                    }
                }
            });
        }

    }
    const initialiseModalCarousel = (elements: NodeListOf<HTMLElement>) => {
        for (const element of elements) {
            const glide = new Glide(element, {
                type: 'carousel',
                perView: 1,
                gap: 0,
                swipeThreshold:false,
                dragThreshold:false,
            });
            setTimeout(() => glide.mount(), 1700);

            markElementReady(element);
        }
        if(modalElement)
            markElementReady(modalElement);
    };
    initialiseModalCarousel(elements);
}

export const loadModalIfApplicable = () => {
    waitForElement('#hub-welcome-modal').then(() => {
        let modalElement = document.querySelector<HTMLElement>('#hub-welcome-modal');
        if (modalElement) {
            elementReady(modalElement).then(() => {
                if(!modalElement) return;
                const myModal = new modal(modalElement); // creating modal object
                myModal.show(); // show modal
                waitForElement('.buyer-type-selection').then(() => {
                    const buyerTypevalue = getCurrentBuyerType();
                    if (buyerTypevalue) {
                        const buyerSelectionButtons = modalElement?.querySelectorAll<HTMLElement>('.buyer-type-selection .button-parent');
                        if (buyerSelectionButtons && buyerSelectionButtons.length > 0) {
                            const currentBuyerTypeButton = Array.from(buyerSelectionButtons).find((button) => {
                                return button.dataset.value === buyerTypevalue;
                            });
                            if (currentBuyerTypeButton) {
                                currentBuyerTypeButton.click();
                            }
                        }
                    }
                });
            });
        }
    });
}
export const toggleLoadingModal = () => {
    let loadingModalElement = document.querySelector<HTMLElement>('.loading-modal-content');
    let welcomeModalElement = document.querySelectorAll<HTMLElement>('.welcome-modal-content');
    if (loadingModalElement && welcomeModalElement) {
        loadingModalElement.classList.toggle('opacity-0');
        loadingModalElement.classList.toggle('h-0');
        welcomeModalElement.forEach((element) => {
            element.classList.toggle('hidden');
        });
    }
}
export const enableSldidingInWelcomeModal = () => {
    const buyerTypeButtonSelection = document.querySelectorAll<HTMLButtonElement>('.buyer-selection-proceed');
    const carouselIndicators = document.querySelectorAll<HTMLButtonElement>('.welcome-modal-content .indicator');
    if (buyerTypeButtonSelection) {
        buyerTypeButtonSelection.forEach((currentButton) => currentButton.removeAttribute('disabled'));
    }
    if (carouselIndicators) {
        carouselIndicators.forEach((currentIndicator) => currentIndicator.removeAttribute('disabled'));
    }

}

const getCurrentBuyerType = () => {
    const query = getQuery();
    const buyerType = query['buyer-type'];
    if (buyerType) {
        switch (buyerType) {
            case 'fhb':
                return "FirstHomeBuyer";
            case 'inv':
                return "Investor";
            case 'up':
                return "Upscaler";
            case 'down':
                return "Downsizer";
            default:
                return "";
        }
    }
}
